import React from 'react'
import { useDispatch } from 'react-redux'

import './cssOverrides.css'
import Alert from '@mui/material/Alert'

import { save } from './actions/save'
import { getUiSchema } from './uiSchemaService'
import { SettingsPopup } from '../SettingsPopup'
import { useSettingsPopupState } from '../hooks'
import { validateSchema } from './utils/validateSchema'
import { useNlp } from '../../../store/flow/hooks/useNlp'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { StepNlpConfigsForm } from './StepNlpConfigsForm/StepNlpConfigsForm'
import { useSchema } from '../sharedSchemaFragments/nlpSettings/hooks/useSchema'
import { useOpenModalOpenSection } from '../../../store/modals/hooks/useOpenModalOpenSection'

export const NlpSettingsPopup: React.FC = React.memo(() => {
  const nlp = useNlp()
  const schema = useSchema()
  const dispatch = useDispatch()
  const openSection = useOpenModalOpenSection() ?? 'form'
  const settingsPopupState = useSettingsPopupState(() => nlp, [openSection])

  const close = () => dispatch(modalsActions.closeModal())
  return (
    <SettingsPopup
      className="no-error-panel"
      customTabNames={{ form: 'Global NLP' }}
      tabOrder={{ form: 0, stepNlpConfigs: 1, json: 2 }}
      close={close}
      schema={schema}
      uiSchema={getUiSchema()}
      openSection={openSection}
      validateSchema={validateSchema}
      formData={settingsPopupState.formData}
      onChange={settingsPopupState.onFormDataChange}
      initialFormData={settingsPopupState.initialFormData}
      save={async formData => {
        await dispatch(save(formData))
        close()
      }}
      additionalSections={[
        {
          tab: { section: 'stepNlpConfigs', label: 'Step NLP' },
          renderContent: props => <StepNlpConfigsForm {...props} key="stepNlp" />
        }
      ]}
      renderBelowForm={
        <Alert severity="info" style={{ fontSize: '13px' }}>
          Global NLP settings have moved. You can now configure them within individual models.
        </Alert>
      }
    />
  )
})
